
export const common = {
  // Navigation
  home: "홈",
  features: "핵심 강점",
  cases: "서비스 사례", 
  pricing: "서비스 가격",
  about: "팀 소개",
  getStarted: "시작하기",
  language: "한국어",

  // Common Actions
  contactUs: "문의하기",
  viewFaq: "FAQ에서 답 찾기",

  // Hero Section
  heroSubtitle: "Flidge, 게임 특화 최고의 로컬라이제이션 서비스",
  heroTitle1: "전 세계 플레이어가",
  heroTitle2: "당신의 게임을 진정으로 이해할 수 있게",
  heroDescription: "최첨단 AI 기술로 정확하고 빠르며 합리적인 다국어 번역 솔루션을 제공합니다. 글로벌 시장에 성공적으로 진출할 수 있도록 돕습니다.",
  learnMore: "장점 알아보기",
  freeTrial: "무료 평가판",
  socialProof: "80개 이상의 게임 개발사와 퍼블리셔의 선택",
  
  // Features Section
  featuresSubtitle: "핵심 강점",
  featuresTitle: "효율적인 게임 현지화 솔루션",
  
  feature1Title: "빠르고 효율적인 작업",
  feature1Description: "정확하고 고품질의 번역을 더 짧은 기간 내에 완료하며, 하루 만에 20만 자의 번역 작업을 처리할 수 있습니다. 게임 프로젝트의 현지화 효율성을 크게 향상시킵니다. 기존 수작업 번역 대비 인적 오류를 대폭 줄이고, 대소문자 및 문장부호 차이를 정확히 식별하며, 번역 품질은 전문 번역 기관의 인증을 받았습니다.",
  
  feature2Title: "다국어 다목적 지원", 
  feature2Description: "전 세계 64개 언어로 번역 서비스를 제공하며, 게임 스크립트, 스토어 페이지, 게임명, 용어집, 공식 웹사이트 등 다양한 콘텐츠 번역을 지원합니다. 모든 현지화 요구사항을 완벽하게 충족시켜 드립니다.",

  // Feature 2 Additional
  glossary: "용어집",
  gameTermsReference: "게임 전문 용어집",
  storePage: "스토어 페이지",
  storePageDesc: "게임명, 게임 소개, 게임 셀링 포인트, 홍보 문구",
  gameStoryTranslation: "게임 시나리오 번역",
  gameStoryDesc: "메인 퀘스트, 서브 퀘스트 스토리",
  completed: "완료",
  inProgress: "번역 중",
  pending: "대기 중",

  feature3Title: "다양한 텍스트 형식 지원",
  feature3Description: "다양한 텍스트 형식의 가져오기 및 내보내기를 지원하여 번역된 텍스트를 게임 프로젝트에 손쉽게 적용할 수 있습니다. 어떤 게임 엔진이든 효율적으로 연동됩니다.",
  
  feature4Title: "게임 전문 현지화 서비스",
  feature4Description: "게임 현지화 번역에 특화되어 게임 텍스트, 대화, UI 등 다양한 콘텐츠 요구사항을 깊이 이해합니다. 풍부한 게임 전문 용어 데이터베이스를 보유하여 더욱 현지화된 게임 경험을 보장하고, 플레이어가 귀하의 게임을 더 잘 이해할 수 있도록 돕습니다.",
  
  // Feature 4 Additional
  professionalGlossary: "전문 용어표",
  professionalTerminologyDatabase: '전문 용어집',
  cheese: 'Cheese',
  feeding: "Feeding",
  rush: "Rush",
  balance: "Balance",
  fightingGamesJapanese: "격투 게임 - 일본어",
  mobaGamesKorean: "MOBA 게임 - 한국어",
  starcraftRussian: "StarCraft - 러시아어",
  actionGamesChinese: "액션 게임 - 중국어",
  more: "더 보기",
  
  // Features Section Additional
  translationTimeComparison: "번역 시간 비교",
  basedOnProject: "20만 자 프로젝트 기준",
  traditionalAgency: "전통적인 번역 업체",
  aiPlatform: "Flidge AI 번역",
  days: "일",
  day: "일",
  hours: "시간",
  hour: "시간",
  "10days": "10일",
  "1day": "1일",
  "240hours": "240시간", 
  "24hours": "24시간",

  // Case Studies Section
  casesSubtitle: "서비스 사례",
  casesTitle: "인디 게임을 전 세계에 알립니다",
  casesDescription: "저희는 모든 협업 기회를 소중히 여기며, 더 많은 인디 게임이 전 세계 더 많은 플레이어들에게 발견될 수 있도록 돕는 것이 저희의 사명입니다",
  
  // Game Types
  platformActionGame: "플랫포머 액션 게임",
  musicRhythmGame: "리듬 게임",
  actionStealthGame: "액션 스텔스 게임",
  casualPuzzleGame: "캐주얼 퍼즐 게임",
  roguelikeCardGame: "시뮬레이션 경영 게임",
  simulationGame: "시뮬레이션 경영 게임",
  
  // Game Descriptions
  haakDescription: "메트로배니아 게임 HAAK에 14개 언어로 번역을 지원해 월 매출 147% 증가를 달성했습니다",
  museDashDescription: "리듬 게임 Muse Dash에 일본어, 한국어, 영어 번역을 지원해 전 세계 수천만 명의 플레이어에게 고품질 현지화 콘텐츠를 제공했습니다",
  kristalaDescription: "액션 잠입 게임 Kristala의 중국어 번역 지원 및 게임명과 스토어 페이지 번역 참여",
  lazyMeowDescription: "캐주얼 퍼즐 게임 Lazy Meow City에 영어, 일본어, 한국어 현지화 지원을 제공하여 아시아 태평양 시장 공략을 지원했습니다",
  stoneSquadDescription: "Cooking Go를 영어, 일본어, 한국어, 프랑스어, 스페인어 등 12개 언어로 현지화",
  catHotelDescription: "CatHotel에 영어, 일본어, 간체 중국어, 번체 중국어로 스토리, 퀘스트, 아이템, 상점 페이지 번역 서비스를 제공하여 현지 사용자에게 최적화된 게임 경험을 제공했습니다",
  
  // Results
  monthlyRevenueGrowth: "월 수익 147% 증가",
  playerReviews: "플레이어 호평",
  translationCompleted: "번역 완료",
  salesIncrease: "매출 증가",
  exposureGrowth: "노출 증가",
  playerReviews2: "플레이어 호평",
  result: "결과",
  customerReviews: '고객 만족도',
  realUserFeedback: '실제 사용자 후기',
  
  // Pricing Section
  pricingSubtitle: "서비스 가격",
  pricingTitle: "투명한 요금제",
  pricingDescription: "다양한 규모의 프로젝트 요구사항을 충족하는 유연한 가격 방안을 제공합니다. 모든 사용자는 무료로 체험하실 수 있습니다.",
  
  freeTrialTitle: "무료 체험 크레딧",
  standardPricing: "표준 가격",
  standardPricingDescription: "무료 한도 초과 시 표준 요금",
  standardPricingFeatures: {
    languages: "64개 언어 번역 지원",
    speed: "24시간 이내 20만 자 번역 완료",
    formats: "다양한 파일 형식 지원",
    glossary: "전문 게임 용어집",
    quality: "품질 관리 서비스"
  },
  customPrice: "커스텀",
  customPlan: "요금제",
  customPlanDescription: "대규모 프로젝트 특별가",
  
  // Enterprise Features
  enterpriseCustom: "기업 맞춤형",
  recommended: "추천",
  perCharacter: "문자당",
  perLanguage: "언어당",
  startUsing: "시작하기",
  contactBusinessTeam: "비즈니스 팀 문의",
  
  enterpriseFeatures: {
    allStandard: "스탠다드 플랜의 모든 기능 포함",
    manager: "전담 매니저 서비스",
    priority: "우선 처리 및 신속 대응",
    customGlossary: "맞춤형 용어집 및 스타일 가이드",
    discount: "대량 할인 및 장기 협력 우대",
    extraTrial: "추가 무료 체험 한도 신청"
  },

  // Pricing Section Additional
  languagesCount: "개 언어",
  freeExperience: "무료 체험", 
  freeTrialDescription: "각 협력 주체당 5,000자, 1개 언어에 대한 무료 체험 할당량이 제공되어 저희의 번역 품질을 충분히 경험하실 수 있습니다",
  
  // New Pricing Calculator Section
  priceCalculator: "가격 계산기",
  calculatorDescription: "프로젝트 번역 비용을 빠르게 산출해 보세요",
  charactersCount: "글자 수",
  targetLanguagesCount: "번역 대상 언어 수",
  estimatedCost: "예상 비용",
  
  calculationNotes: "계산 설명",
  calculationDetails: {
    freeQuota: "각 협력 주체는 5,000자 무료 할당량 제공 (단일 언어에 한함)",
    pricing: "무료 할당량 초과 시 $0.011/자/언어로 책정",
    bulkDiscount: "대량 프로젝트의 경우 기업 맞춤 할인가 적용 가능",
    finalPrice: "최종 가격은 영업팀 견적을 기준으로 함"
  },

  // About Section
  aboutSubtitle: "팀 소개",
  aboutTitle: "전문 게임 로컬라이제이션 서비스 팀",
  aboutDescription: "Flidge는 2019년에 설립된 게임 로컬라이제이션 전문 기술 기업입니다. AI 기술과 전문 인력의 검수를 결합하여 전 세계 게임 개발자들에게 고품질의 효율적인 다국어 로컬라이제이션 서비스를 제공하며, 우수한 게임 작품이 세계로 나아갈 수 있도록 돕습니다.",
  
  ourMission: "우리의 사명",
  ourVision: "우리의 비전",
  missionText: "첨단 AI 기술과 전문적인 로컬라이제이션 서비스를 통해 언어 장벽을 허물고, 모든 우수한 게임이 글로벌 시장에서 성공할 수 있도록 하며, 전 세계 게이머들이 최고의 게임 경험을 누릴 수 있도록 합니다.",
  visionText: "기술 혁신과 전문 서비스로 게임 산업의 글로벌 발전에 기여하며, 우수한 게임 문화를 전 세계에 전파하는 글로벌 최고의 게임 로컬라이제이션 플랫폼을 지향합니다.",
  
  // FAQ Section
  faqSubtitle: '자주 묻는 질문',
  faqTitle: '자주 묻는 질문과 답변',
  faqDescription: '더 궁금한 점이 있으시면 언제든지 문의해 주세요',
  stillHaveQuestions: "궁금한 점이 있으신가요?",
  
  faqQuestion1: '무료 체험 할당량을 제공받을 수 있나요?',
  faqQuestion2: '게임 개발 어느 단계에서 Flidge 서비스를 이용하는 것이 좋나요?',
  faqQuestion3: '게임 프로젝트에 용어집이 없으면 어떻게 해야 하나요?',
  faqQuestion4: '제 게임 콘텐츠의 기밀이 철저히 보장되나요?',
  
  // FAQ Items
  faq1Question: "무료 체험 할당량을 제공받을 수 있나요?",
  faq1Answer: "저희는 각 파트너사에게 5,000자, 단일 언어 번역에 한해 무료 체험 할당량을 제공합니다. 5,000자 초과분은 문자당/언어당 0.016달러의 요금이 부과됩니다. 추가 무료 체험 할당량이 필요하신 경우, 저희 영업팀에 문의하여 신청하실 수 있습니다.",
  
  faq2Question: "게임 개발 어느 단계에서 Flidge 서비스를 이용하는 것이 좋나요?",
  faq2Answer: "게임 프로젝트 개발 프로세스의 중반 이후에 Flidge 서비스를 이용하시길 권장합니다. 이를 통해 현지화 비용을 최대한 절감하실 수 있으며, 동시에 스토어 페이지 번역 지원과 귀하의 게임에 더 적합한 현지화 게임명을 선별해 드려, 플레이어들이 귀하의 게임을 더 쉽게 기억하고 글로벌 시장 개척에 도움이 되도록 합니다. 게임이 Steam 등의 게임 플랫폼에 곧 출시될 예정이라면, Flidge의 서비스가 매우 적합합니다. 저희는 단기간 내에 다수 언어의 현지화 작업을 완료하여, 전 세계 플레이어들이 귀하의 게임을 발견할 수 있도록 돕습니다.",
  
  faq3Question: "게임 프로젝트에 용어집이 없으면 어떻게 해야 하나요?",
  faq3Answer: "Flidge AI는 용어집 정리 서비스를 제공하여 프로젝트와 번역할 콘텐츠를 체계적으로 관리하고, 용어 사용 방식을 함께 검토 및 확인함으로써 게임 내 정확한 적용을 보장합니다.|용어집 정리 서비스가 필요하시면 언제든지 문의해 주시기 바랍니다.",
  
  faq4Question: "제 게임 콘텐츠의 기밀이 철저히 보장되나요?",
  faq4Answer: "저희는 업계 표준 수준의 암호화 기술과 게임 프로젝트에 특화된 분리된 작업 환경을 운영합니다. 모든 팀원은 명확한 손해배상 책임 조항이 포함된 엄격한 기밀유지 계약 하에 업무를 수행합니다. 저희 개발 환경은 완벽한 자산 격리를 보장합니다—스크린샷 금지, 외부 드라이브 금지, 개인 기기 사용 금지. 유출된 게임 화면, 스토리 요소 또는 출시일이 게임의 시장 영향력을 훼손할 수 있음을 잘 알고 있습니다. 귀하의 창작 지적재산권은 저희가 자체 미공개 프로젝트에 적용하는 것과 동일한 수준의 보호를 받게 됩니다.",
  
  // CTA Section
  ctaTitle1: "세계를 사로잡을",
  ctaTitle2: "당신의 게임",
  
  // Contact Section
  contactSubtitle: "문의하기",
  contactTitle: "전문 번역 서비스 및 무료 체험 혜택 받기",
  contactDescription: "아래 양식을 작성해 주시면 전문가가 24시간 내에 맞춤 견적을 보내드립니다",
  
  name: "이름",
  email: "이메일",
  company: "회사/스튜디오명",
  targetLanguages: "번역 대상 언어",
  projectDetails: "프로젝트 상세 정보",
  getQuote: "견적 받기",
  onlineConsult: "온라인 상담",
  emailContact: "이메일 문의",
  
  // Footer
  footerDescription: "인디 게임 개발자를 위해 효율적이고 편리하며 합리적인 가격의 로컬라이제이션 서비스를 제공합니다. 지능형 번역, 분석 및 맞춤형 언어 서비스를 통해 게임 프로젝트의 글로벌 성장을 지원합니다.",
  services: "서비스",
  companySection: "회사",
  resources: "리소스",
  featuresLink: "핵심 강점",
  pricingConsult: "가격",
  aboutUs: "팀 소개",
  helpCenter: "도움말 센터",
  techBlog: "기술 블로그",
  termsOfService: "서비스 약관",
  privacyPolicy: "개인정보 보호정책",
  cookiePolicy: "쿠키 정책",
  poweredBy: "Powered by Readdy",
  copyright: "© 2026 Shenzhen Giant Core Limited. All rights reserved.",
  
  // Form labels
  required: "*",
  characterCount: "문자",
  
  // Form placeholders
  namePlaceholder: "이름을 입력해 주세요",
  emailPlaceholder: "이메일 주소를 입력해 주세요",
  companyPlaceholder: "회사 또는 스튜디오 이름을 입력해 주세요",
  languagesPlaceholder: "예: 영어, 일본어, 한국어 등",
  messagePlaceholder: "게임 유형, 번역 콘텐츠, 특별 요구사항 등을 포함한 프로젝트 요구사항을 자세히 설명해 주세요...",
  
  // Alt texts
  gameIcon: "게임 아이콘",
  flidgeLogo: "Flidge 로고",
  abstractShape: "추상 모양",
  
  // Testimonials
  testimonialSarahRole: "인디 게임 개발자",
  testimonialSarahContent: "Flidge를 사용한 후 우리 게임의 해외 시장 반응이 매우 좋습니다. 번역 품질이 기대 이상이었고, 플레이어들은 스토리가 자연스럽게 전달되어 기계 번역 같지 않다는 피드백을 주었습니다.",
  
  testimonialThijsRole: "게임 스튜디오 디렉터",
  testimonialThijsContent: "초기 시나리오 번역부터 후반 텍스트 최적화까지, Flidge 팀은 매우 높은 전문성을 보여주었습니다. 게임 문화에 대한 깊은 이해로 현지화 작업이 한층 원활해졌습니다.",
  
  testimonialEmmaRole: "게임 현지화 매니저",
  testimonialEmmaContent: "Flidge의 번역 서비스 덕분에 많은 시간과 비용을 절약할 수 있었습니다. 그들의 AI 기술은 빠를 뿐만 아니라 게임 내 전문 용어와 문화적 뉘앙스를 정확하게 이해합니다.",
  
  testimonialDavidRole: "게임 프로듀서",
  testimonialDavidContent: "우리 게임이 일본과 한국 시장에서 큰 성공을 거둔 것은 Flidge가 제공한 우수한 현지화 서비스 덕분입니다. 동아시아 문화에 대한 그들의 깊은 이해 덕분에 번역이 더욱 자연스러워졌습니다.",
  
  testimonialAlexRole: "인디 개발자",
  testimonialAlexContent: "소규모 팀으로서 가장 걱정했던 것이 현지화 비용이었습니다. Flidge는 합리적인 가격에 효율성도 뛰어나 여러 해외 시장에 동시에 진출할 수 있었습니다.",
  
  testimonialYukiRole: "게임 기획자",
  testimonialYukiContent: "Flidge의 일본 게임 문화에 대한 이해가 인상 깊었습니다. 단순히 텍스트를 번역하는 것을 넘어 게임의 정수를 전달해, 해외 플레이어들도 본래의 매력을 그대로 느낄 수 있었습니다.",
  
  abstractShape2: "추상 모양 2",

  // New entries from modification
  partners: "파트너",
  trustedPartners: "믿을 수 있는 파트너",
  partnersDescription: "글로벌 최고 수준의 게임 팀 및 기업과의 장기적이고 긴밀한 협력 관계",

  gameProjectsServed: "누적 파트너사",
  supportedLanguages: "지원 가능 언어",
  clientSatisfaction: "고객 만족도",
  responseTime: "평균 응답 시간",

  // Additional Metrics
  translatedCharactersCount: "500만+",
  avgTranslationSpeedValue: "3.2초",
  translatedCharacters: "번역 문자 수",
  avgTranslationSpeed: "천 자 기준 평균 번역 소요 시간",
  clientSatisfactionRate: "만족도",
  servicedCompanies: "서비스 이용 업체 수",
  successMetrics: "성공 지표",
  serviceImpact: "서비스의 영향력",

  // Statistics
  stat1Number: '80+',
  stat1Label: '누적 파트너사',
  stat2Number: '64',
  stat2Label: '지원 가능 언어',
  stat3Number: '97%',
  stat3Label: '고객 만족도',
  stat4Number: '24시간',
  stat4Label: '평균 응답 시간',

  // Terms of Service
  termsTitle: '서비스 약관',
  termsLastUpdated: '최종 업데이트: 2025년 1월',
  terms1Title: '1. 약관 동의',
  terms1Content: 'Flidge AI 번역 서비스에 접근하고 사용함으로써 본 계약의 조건과 규정에 구속되는 것에 동의합니다.',
  terms2Title: '2. 사용 라이선스',
  terms2Content: 'Flidge 웹사이트의 자료를 개인적, 비상업적 임시 열람 목적으로만 다운로드할 수 있는 권한이 부여됩니다.',
  terms3Title: '3. 면책 조항',
  terms3Content: 'Flidge 웹사이트의 자료는 "있는 그대로" 제공됩니다. Flidge는 명시적 또는 묵시적 보증을 하지 않습니다.',
  terms4Title: '4. 제한 사항',
  terms4Content: '어떤 경우에도 Flidge 또는 그 공급업체는 자료 사용 또는 사용 불능으로 인한 손해에 대해 책임지지 않습니다.',
  terms5Title: '5. 자료의 정확성',
  terms5Content: 'Flidge 웹사이트에 나타나는 자료에는 기술적, 인쇄상 또는 사진상의 오류가 포함될 수 있습니다.',
  terms6Title: '6. 링크',
  terms6Content: 'Flidge는 우리 웹사이트에 연결된 모든 사이트를 검토하지 않았으며 그러한 연결된 사이트의 내용에 대해 책임지지 않습니다.',
  terms7Title: '7. 수정',
  terms7Content: 'Flidge는 언제든지 예고 없이 웹사이트의 서비스 약관을 수정할 수 있습니다.',
  terms8Title: '8. 준거법',
  terms8Content: '이 약관과 조건은 적용 법률에 따라 규율되고 해석됩니다.',

  // Privacy Policy
  privacyTitle: '개인정보 보호정책',
  privacyLastUpdated: '최종 업데이트: 2025년 1월',
  privacy1Title: '1. 수집하는 정보',
  privacy1Content: '계정 생성, 번역 서비스 사용 또는 지원 문의 시 직접 제공하는 정보를 수집합니다.',
  privacy2Title: '2. 정보 사용 방법',
  privacy2Content: '수집된 정보를 번역 서비스 제공, 유지 및 개선을 위해 사용합니다.',
  privacy3Title: '3. 정보 공유',
  privacy3Content: '동의 없이 개인정보를 제3자에게 판매, 거래 또는 양도하지 않습니다.',
  privacy4Title: '4. 데이터 보안',
  privacy4Content: '개인정보를 보호하기 위해 적절한 보안 조치를 구현합니다.',
  privacy5Title: '5. 데이터 보존',
  privacy5Content: '서비스 제공에 필요한 기간 동안 개인정보를 보존합니다.',
  privacy6Title: '6. 귀하의 권리',
  privacy6Content: '개인정보에 대한 접근, 업데이트 및 삭제 요청 권리가 있습니다.',
  privacy7Title: '7. 쿠키 및 추적',
  privacy7Content: '웹사이트 경험 향상을 위해 쿠키와 유사한 추적 기술을 사용합니다.',
  privacy8Title: '8. 국제 전송',
  privacy8Content: '귀하의 정보는 다른 국가로 전송되어 처리될 수 있습니다.',
  privacy9Title: '9. 정책 변경',
  privacy9Content: '이 개인정보 보호정책을 수시로 업데이트할 수 있습니다.',
  privacy10Title: '10. 문의하기',
  privacy10Content: '이 개인정보 보호정책에 대한 질문이 있으시면 privacy@flidge.ai로 문의하십시오.',

  // Cookie Policy
  cookieTitle: '쿠키 정책',
  cookieLastUpdated: '최종 업데이트: 2025년 1월',
  cookie1Title: '1. 쿠키란 무엇인가',
  cookie1Content: '쿠키는 웹사이트 방문 시 기기에 저장되는 작은 텍스트 파일입니다.',
  cookie2Title: '2. 사용하는 쿠키 유형',
  cookie2Content: '기본 웹사이트 기능을 위한 필수 쿠키, 사용 패턴 분석을 위한 성능 쿠키, 기능 쿠키를 사용합니다.',
  cookie2Essential: '필수 쿠키',
  cookie2EssentialDesc: '이 쿠키들은 웹사이트가 제대로 작동하는 데 필요합니다.',
  cookie2Performance: '성능 쿠키',
  cookie2PerformanceDesc: '이 쿠키들은 방문자가 웹사이트를 어떻게 사용하는지에 대한 정보를 수집합니다.',
  cookie2Functional: '기능 쿠키',
  cookie2FunctionalDesc: '이 쿠키들은 웹사이트가 귀하의 선택을 기억할 수 있게 합니다.',
  cookie3Title: '3. 제3자 쿠키',
  cookie3Content: '기기에 쿠키를 저장하는 제3자 서비스를 사용할 수 있습니다.',
  cookie4Title: '4. 쿠키 관리',
  cookie4Content: '브라우러 설정을 통해 쿠키를 제어하고 관리할 수 있습니다.',
  cookie5Title: '5. 쿠키 동의',
  cookie5Content: '웹사이트 계속 사용으로 이 정책에 설명된 쿠키 사용에 동의하는 것으로 간주됩니다.',
  cookie6Title: '6. 쿠키 비활성화의 영향',
  cookie6Content: '쿠키를 비활성화하면 웹사이트의 일부 기능이 제대로 작동하지 않을 수 있습니다.',
  cookie7Title: '7. 정책 업데이트',
  cookie7Content: '이 쿠키 정책을 수시로 업데이트할 수 있습니다.',
  cookie8Title: '8. 연락처 정보',
  cookie8Content: '쿠키 사용에 대한 질문이 있으시면 cookies@flidge.ai로 문의하십시오.'
};

export default common;
